import React from 'react';
import {Icon, Button} from 'antd';
import Template from '../interfaz/Template';
import {borrarOperacion} from '../../redux/actions/accionesOperacion'
import {connect} from 'react-redux'
import { Link } from "react-router-dom";
import operacionExitosa from '../../img/info15_cambios_guardados_validacion_docs.png';

let radioDecision = new Boolean(false);
let asignaSede = new Boolean(false);


class OperacionExitosa extends React.Component {
    infoSede = {
        sede: "",
        fechaProgramada: "",
        horaProgramada: ""
    } 

    constructor(props) {
        super(props);

        if (!this.props.operaciones)
            this.props.history.push('/loginSEyCAE');
    }

    componentWillUnmount() {
        this.props.borrarOperacion();
    }

    continuar = () => {
        this.props.history.push(this.props.operaciones.irA);
    }

    render() {
        const operaciones = this.props.operaciones || {};
        console.log(this.props.operaciones.radioDecision);
        if(this.props.operaciones.radioDecision === undefined || this.props.operaciones.radioDecision === "false" || 
            this.props.operaciones.radioDecision === "true"){
            radioDecision = "false";
        }else if(this.props.operaciones.radioDecision === 'permite'){
            radioDecision = "true";
        }
      
        const revisoFechaHora = (this.props.operaciones.infoSede.fechaProgramada !== undefined && this.props.operaciones.infoSede.horaProgramada !== undefined) ? true: false;
        
        if ((this.props.operaciones.asignaSede !== undefined || this.props.operaciones.asignaSede === "true") && revisoFechaHora) { 
            asignaSede = "true";

            if (this.props.operaciones.infoSede !== undefined && revisoFechaHora) {
                this.infoSede.sede = this.props.operaciones.infoSede.sede;
                this.infoSede.fechaProgramada = this.props.operaciones.infoSede.fechaProgramada.split('T')[0];
                this.infoSede.horaProgramada = this.props.operaciones.infoSede.horaProgramada;
            }
        }

        const deshacerDeclinacion = operaciones && operaciones.deshacerDeclinacion ? operaciones.deshacerDeclinacion : false;

        return(
            <Template contenido={
                <React.Fragment>
                    <div className="exito_container">
                        <div style={{ 'margin': '90px auto 10px auto' }}>
                            {asignaSede === 'true' && this.infoSede.sede !== undefined && (this.infoSede.sede !== undefined ? this.infoSede.sede !== "" ? true : false : false)?
                                <p>
                                    <p style={{ 'font-size': 'large', textAlign: 'center', 'margin-bottom': '5px' }}>
                                        <b>Informaci&oacute;n para el examen </b>
                                    </p>
                                    <p style={{ 'border': '1px solid', 'border-color': "#409AA1", 'padding': '5px'}}>                                   
                                        <p>
                                            <span><b>Sede: </b></span> &nbsp; <span>{this.infoSede.sede}</span>  <br />
                                            <span><b>Fecha programada: </b></span>&nbsp;<span>{this.infoSede.fechaProgramada}</span> <br />
                                            <span><b>Hora programada: </b></span> &nbsp; <span>{this.infoSede.horaProgramada} hrs. (hora centro del país)</span>  <br /> <br />
                                            <span>El participante deber&aacute; presentarse 30 minutos antes para su examen. </span>                                
                                        </p>
                                    </p>
                                </p>
                                :
                                null
                      
                            }
                            <center>
                                <p/>
                                    <img src={operacionExitosa} alt="OperacionExitosa" width="100%" height="100%"/>
                                <p/>
                            </center>
                            {radioDecision === 'true' && deshacerDeclinacion === false ?
                                <Link className='exito_detalle' to='/cargaDocumentos'>
                                    Ir a Carga de documentos
                                </Link> : 
                                null
                            }
                        </div>
                    </div>
                    {operaciones.irA ? (
                        <div className='exito_continuar'>
                            <Button onClick={this.continuar}>Siguiente <Icon type="arrow-right" /></Button>
                        </div>
                    ) : null}
                </React.Fragment>
            }
            guia={false}
            contenidoExpandido={true}/>
        );
    }
};

const mapStateToProps = state => {
    return {
        operaciones: state.operaciones,
        datosAspirante: state.user.datosAspirante
    }
}

const mapDispatchToProps = {
    borrarOperacion
}

export default connect(mapStateToProps, mapDispatchToProps)(OperacionExitosa);